import React from "react";

function Impressum() {
  return (
    <div className="mx-auto max-w-[820px] rounded-card border border-line bg-surface p-6 md:p-8">
      <h1 className="border-b-2 border-ink pb-3 font-head text-[26px] font-bold text-ink">
        Rreth nesh
      </h1>

      <div className="mt-5 flex flex-col gap-4 text-[14.5px] leading-relaxed text-ink">
        <p>
          lajm.ai është një agregator lajmesh në gjuhën shqipe, i ndërtuar me
          inteligjencë artificiale. Synimi është krijimi i një pasqyre të
          përgjithshme të ngjarjeve aktuale.
        </p>
        <p>
          Platforma mbledh lajmet e fundit nga faqet relevante dhe i grupon
          sipas temave dhe ngjarjeve, duke mundësuar dhe krahasimin mes
          raportimit nga media të ndryshme, si dhe identifikimin e personazheve
          në qendër të vëmendjes. Majtas shfaqet lista e entiteteve (personazhe
          ose institucione) që përmenden më shpesh në lajmet e 36 orëve të
          fundit. Djathtas, funksioni i kërkimit ju ndihmon të kërkoni brenda
          lajmeve të 36 orëve të fundit për çdo emër, temë ose fjalë kyçe që ju
          intereson.
        </p>
        <p>
          Platforma nuk prodhon lajme apo materiale të tjera origjinale; ajo
          vetëm analizon dhe i organizon përmbajtjet e faqeve të tjera. Lajmet
          procesohen nga algoritme që kemi dizajnuar dhe vazhdojmë t'i
          përmirësojmë.
        </p>
        <p>
          Një shtyllë e rëndësishme e projektit është respektimi i të drejtave
          të autorit. Platforma shfaq vetëm titullin original të artikullit, një
          fragment të shkurtër dhe një figurë të vogël shoqëruese. Nëse dëshironi
          të lexoni të gjithë artikullin, klikoni mbi titullin dhe dërgoheni në
          faqen origjinale të medias.
        </p>
        <p>
          lajm.ai nuk është portal lajmesh dhe nuk përfaqëson asnjë parti
          politike apo media të veçantë; është një mjet eksperimental që
          kombinon AI dhe lajmet për të rritur transparencën.
        </p>
      </div>

      <div className="mt-7 border-t border-line pt-5">
        <h2 className="font-head text-[18px] font-bold text-ink">Kontakt</h2>
        <p className="mt-2 text-[14px] text-ink">
          Email:{" "}
          <a
            href="mailto:contact@lajm.ai"
            className="font-semibold text-brand hover:underline"
          >
            contact@lajm.ai
          </a>
        </p>
      </div>

      <div className="mt-7 border-t border-line pt-5 text-center text-[12px] text-sub">
        © {new Date().getFullYear()} lajm.ai. Të gjitha të drejtat e rezervuara.
      </div>
    </div>
  );
}

export default Impressum;
